// extracted by mini-css-extract-plugin
export default {"container":"General_container__tfB+4","inputItem":"General_inputItem__iHXM+","selectButton":"General_selectButton__mNeqr","button":"General_button__0hTqQ"};